import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://my.casellanoleggiobus.it/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor per aggiungere token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor per gestire refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL || 'https://my.casellanoleggiobus.it/api'}/auth/token/refresh/`,
          { refresh: refreshToken }
        );

        const { access } = response.data;
        localStorage.setItem('accessToken', access);

        originalRequest.headers.Authorization = `Bearer ${access}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('utente');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

/**
 * Scarica un elenco COMPLETO, seguendo la paginazione.
 *
 * Le liste dell'API sono paginate a 20 elementi: usare direttamente
 * `data.results` significa contare e mostrare solo la prima pagina. Questo
 * helper chiede pagine grandi e prosegue finché il server segnala altre
 * pagine, restituendo sempre un array.
 */
export const getAll = async (url, params = {}) => {
  const risposta = await api.get(url, { params: { ...params, page_size: 500 } });
  const dati = risposta.data;

  // Endpoint senza paginazione: restituiscono già l'array
  if (Array.isArray(dati)) return dati;

  let elementi = dati.results || [];
  let successiva = dati.next;

  // Oltre le 500 righe si continua pagina per pagina
  while (successiva) {
    const altra = await api.get(successiva);
    elementi = elementi.concat(altra.data.results || []);
    successiva = altra.data.next;
  }

  return elementi;
};

export default api;

